import { Component, OnInit, ViewChild } from '@angular/core';

@Component({
    selector: 'app-view-all-order-details',
    templateUrl: './view-all-order-details.component.html',
    styleUrls: ['./view-all-order-details.component.scss'],
    standalone: false
})

export class ViewAllOrderDetailsComponent implements OnInit {
  @ViewChild('calendar') calendar: any;
  states: any;
  selectedState: any;
  rangeDates: Date[] = [];
  selectedDate = new Date();
  totalOrders: number = 100;
  inprogressOrders: number = 29;
  completedOrders: number = 66;
  canceledOrder: number = 3;
  incrementValue: boolean = true;
  constructor(
    ) {


  }

  ngOnInit(): void {
  }

  filterState(event: any) {
   
  }

  onSelect() {
    if (this.rangeDates[1]) {
      this.calendar.overlayVisible = false;
    }
  }
}
